import { Temporal } from "proposal-temporal";

function format(plainDate) {
  return plainDate.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function* fridaysThe13th(startDate = Temporal.now.plainDateISO()) {
  let date = startDate;
  while (true) {
    date = nextFriday13th(date);
    yield date;
  }
}

function nextFriday13th(startDate = Temporal.now.plainDateISO()) {
  let nf = nextFriday(startDate);

  while (true) {
    if (nf.day === 13) {
      return nf;
    }
    nf = nextFriday(nf);
  }
}

function nextFriday(startDate = Temporal.now.plainDateISO()) {
  const friday = 5;
  let newDate = startDate;

  while (true) {
    if (newDate.dayOfWeek === friday) {
      return newDate.add({ days: 7 });
    }
    newDate = newDate.add({ days: 1 });
  }
}

export { fridaysThe13th, format };
